// extracted by mini-css-extract-plugin
export var lg = "_4d-4";
export var md = "_4d-3";
export var sm = "_4d-2";
export var xs = "_4d-1";
export var xxs = "_4d-0";